module.exports = __webpack_public_path__ + "static/media/index-shop-0.cd694090.webp";